/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "Shalay",
        "0": "Maanta",
        "1": "Berri",
        "future": {
          "one": "{0} maalin",
          "other": "{0} maalmood"
        },
        "past": {
          "one": "{0} maalin kahor",
          "other": "{0} maalmood kahor"
        }
      },
      "day-narrow": {
        "-1": "Shalay",
        "0": "Maanta",
        "1": "Berri",
        "future": {
          "one": "{0} mln",
          "other": "{0} mlmd"
        },
        "past": {
          "one": "{0} mln khr",
          "other": "{0} mlmd khr"
        }
      },
      "day-short": {
        "-1": "Shalay",
        "0": "Maanta",
        "1": "Berri",
        "future": {
          "one": "{0} mln",
          "other": "{0} mlmd"
        },
        "past": {
          "one": "{0} mln khr",
          "other": "{0} mlmd khr"
        }
      },
      "hour": {
        "0": "Saacadan",
        "future": {
          "one": "{0} saacad",
          "other": "{0} saacadood"
        },
        "past": {
          "one": "{0} saacad kahor",
          "other": "{0} saacadood kahor"
        }
      },
      "hour-narrow": {
        "0": "Saacadan",
        "future": {
          "one": "{0} scd",
          "other": "{0} scd"
        },
        "past": {
          "one": "{0} scd khr",
          "other": "{0} scd khr"
        }
      },
      "hour-short": {
        "0": "Saacadan",
        "future": {
          "one": "{0} scd",
          "other": "{0} scd"
        },
        "past": {
          "one": "{0} scd khr",
          "other": "{0} scd khr"
        }
      },
      "minute": {
        "0": "Daqiiqadan",
        "future": {
          "one": "{0} daqiiqad",
          "other": "{0} daqiidadood"
        },
        "past": {
          "one": "{0} daqiiqad kahor",
          "other": "{0} daqiiqadood kahor"
        }
      },
      "minute-narrow": {
        "0": "Daqiiqadan",
        "future": {
          "one": "{0} dqqd",
          "other": "{0} dqqd"
        },
        "past": {
          "one": "{0} dqqd khr",
          "other": "{0} daqiiqadood kahor"
        }
      },
      "minute-short": {
        "0": "Daqiiqadan",
        "future": {
          "one": "{0} dqqd",
          "other": "{0} dqqd"
        },
        "past": {
          "one": "{0} dqqd khr",
          "other": "{0} daqiiqadood kahor"
        }
      },
      "month": {
        "-1": "Bishii hore",
        "0": "Bishan",
        "1": "Bisha danbe",
        "future": {
          "one": "{0} bil",
          "other": "{0} bilood"
        },
        "past": {
          "one": "{0} bil kahor",
          "other": "{0} bilood kahor"
        }
      },
      "month-narrow": {
        "-1": "Bishii hore",
        "0": "Bishan",
        "1": "Bisha danbe",
        "future": {
          "one": "{0} bil",
          "other": "{0} bil"
        },
        "past": {
          "one": "{0} bil khr",
          "other": "{0} bil khr"
        }
      },
      "month-short": {
        "-1": "Bishii hore",
        "0": "Bishan",
        "1": "Bisha danbe",
        "future": {
          "one": "{0} bil",
          "other": "{0} bil"
        },
        "past": {
          "one": "{0} bil khr",
          "other": "{0} bil khr"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "Rubucii hore",
        "0": "Rubucan",
        "1": "Rubuca danbe",
        "future": {
          "one": "{0} rubuc",
          "other": "{0} rubuc"
        },
        "past": {
          "one": "{0} rubuc kahor",
          "other": "{0} rubuc kahor"
        }
      },
      "quarter-narrow": {
        "-1": "Rubucii ugu dambeeyay",
        "0": "Rubucan",
        "1": "Rubuca xiga",
        "future": {
          "one": "{0} rbc",
          "other": "{0} rbc"
        },
        "past": {
          "one": "{0} rbc khr",
          "other": "{0} rbc khr"
        }
      },
      "quarter-short": {
        "-1": "Rubucii ugu dambeeyay",
        "0": "Rubucan",
        "1": "Rubuca xiga",
        "future": {
          "one": "{0} rbc",
          "other": "{0} rbc"
        },
        "past": {
          "one": "{0} rbc khr",
          "other": "{0} rbc khr"
        }
      },
      "second": {
        "0": "Imika",
        "future": {
          "one": "{0} ilbiriqsi",
          "other": "{0} ilbiriqsi"
        },
        "past": {
          "one": "{0} ilbiriqsi kahor",
          "other": "{0} ilbiriqsi kahor"
        }
      },
      "second-narrow": {
        "0": "Iminka",
        "future": {
          "one": "{0} ilbrqsi",
          "other": "{0} ilbrqsi"
        },
        "past": {
          "one": "{0} ilbrqsi khr",
          "other": "{0} ilbrqsi khr"
        }
      },
      "second-short": {
        "0": "Iminka",
        "future": {
          "one": "{0} ilbrqsi",
          "other": "{0} ilbrqsi"
        },
        "past": {
          "one": "{0} ilbrqsi khr",
          "other": "{0} ilbrqsi khr"
        }
      },
      "week": {
        "-1": "Toddobaadkii hore",
        "0": "Usbuucan",
        "1": "Toddobaadka danbe",
        "future": {
          "one": "{0} toddobaad",
          "other": "{0} toddobaad"
        },
        "past": {
          "one": "{0} toddobaad kahor",
          "other": "{0} toddobaad kahor"
        }
      },
      "week-narrow": {
        "-1": "Toddobaadkii hore",
        "0": "Toddobaadkan",
        "1": "Toddobaadka danbe",
        "future": {
          "one": "{0} tdbd",
          "other": "{0} tdbd"
        },
        "past": {
          "one": "{0} tdbd khr",
          "other": "{0} tdbd khr"
        }
      },
      "week-short": {
        "-1": "Toddobaadkii hore",
        "0": "Usbuucan",
        "1": "Toddobaadka danbe",
        "future": {
          "one": "{0} tdbd",
          "other": "{0} tdbd"
        },
        "past": {
          "one": "{0} tdbd khr",
          "other": "{0} tdbd khr"
        }
      },
      "year": {
        "-1": "Sannadkii hore",
        "0": "Sannadkan",
        "1": "Sannadka danbe",
        "future": {
          "one": "{0} sannad",
          "other": "{0} sannadood"
        },
        "past": {
          "one": "{0} sannad kahor",
          "other": "{0} sannadood kahor"
        }
      },
      "year-narrow": {
        "-1": "Sannadkii la soo dhaafay",
        "0": "Sannadkan",
        "1": "Sannadka xiga",
        "future": {
          "one": "{0} snd",
          "other": "{0} snd"
        },
        "past": {
          "one": "{0} snd khr",
          "other": "{0} Snd khr"
        }
      },
      "year-short": {
        "-1": "Sannadkii hore",
        "0": "Sannadkan",
        "1": "Sannadka danbe",
        "future": {
          "one": "{0} snd",
          "other": "{0} snd"
        },
        "past": {
          "one": "{0} snd khr",
          "other": "{0} Snd khr"
        }
      }
    },
    "locale": "so-DJ"
  });
}